export default "__VITE_ASSET__4b82b8dc__"